import { ChatAgent } from './components/ChatAgent';
import { ChatAppEntry } from './components/ChatAppEntry';
import { Create } from './components/Create';
import { Edit } from './components/Edit';
import { Edit as EditVariantA } from './components/EditVariantA';
import { Edit as EditVariantB } from './components/EditVariantB';
import { Intro } from './components/Intro';
import { IssuePrompt } from './components/IssuePrompt';
import { Location } from './components/Location';
import { Media } from './components/Media';
import { OptionalPreview } from './components/OptionalPreview';
import { PersonalPrompt } from './components/PersonalPrompt';
import { PrePublish } from './components/PrePublish';
import { Preview } from './components/Preview';
import { Preview as PreviewVariantA } from './components/PreviewVariantA';
import { Preview as PreviewVariantB } from './components/PreviewVariantB';
import { SocialEntry } from './components/SocialEntry';
import { usePageBody } from './hooks/usePageBody';

export function PageBody() {
	const { data, actions } = usePageBody();

	// oxlint-disable-next-line complexity
	const Component = (() => {
		switch (true) {
			case actions.matches('intro') && data.flowId === 'chat_agent':
				return <ChatAgent />;
			case actions.matches('start') && data.flowId === 'chat_agent':
				return <Intro />;
			case actions.matches('intro'):
				return <Intro />;
			case actions.matches('issue'):
				return <IssuePrompt />;
			case actions.matches('personal-story'):
				return <PersonalPrompt />;
			case actions.matches('chat-app-entry'):
				return <ChatAppEntry />;
			case actions.matches('social'):
				return <SocialEntry />;
			case actions.matches('optional-preview'):
				return <OptionalPreview />;
			case actions.matches('preview') && data.flowId === 'preview_edit_variant_a':
				return <PreviewVariantA />;
			case actions.matches('preview') && data.flowId === 'preview_edit_variant_b':
				return <PreviewVariantB />;
			case actions.matches('preview'):
				return <Preview />;
			case actions.matches('create'):
				return <Create />;
			case actions.matches('edit') && data.flowId === 'preview_edit_variant_a':
				return <EditVariantA />;
			case actions.matches('edit') && data.flowId === 'preview_edit_variant_b':
				return <EditVariantB />;
			case actions.matches('edit'):
				return <Edit />;
			case actions.matches('location'):
				return <Location />;
			case actions.matches('media'):
				return <Media />;
			case actions.matches('prepublish'):
				return <PrePublish />;
			default:
				// probably throw an error here and handle in error boundary?
				return <div>unknown state</div>;
		}
	})();

	return Component;
}
